// extracted by mini-css-extract-plugin
export var card = "_kf-5";
export var cardSelected = "_kf-4";
export var image = "_kf-3";
export var modal = "_kf-0";
export var modalContent = "_kf-1";
export var table = "_kf-2";